// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2LFuM","info":"UpdateTermsInfo_info__2MfrO"};